<main>
    <div class="content">

        <!-- English -->
        <div class="paragraph" *ngIf="selectedCareer && isEnglish()">
            <h2>{{ selectedCareer.title }}</h2>
            <p *ngIf="selectedCareer.branches">{{ 'career.Locations' | translate }}: </p>
            <p [innerHTML]="selectedCareer.branches | safeText"></p>
            <p style="margin-top: 50px;">{{ 'career.Closing date' | translate }}: {{ selectedCareer.close_date | dateFormat }}</p>
            <hr>
            <h1 *ngIf="selectedCareer.duties">{{ 'career.Job Duties and Responsibilities' | translate }}</h1>
            <p [innerHTML]="selectedCareer.duties | safeText"></p>
            <h1 *ngIf="selectedCareer.competencies">{{ 'career.Benefits' | translate }}</h1>
            <p [innerHTML]="selectedCareer.competencies | safeText"></p>
            <hr>
            <h1>{{ 'career.How to apply' | translate }}</h1>
            <p>{{ 'career.Interested candidates should submit a CV, Cover Letter, and recent passport photograph, clearly mentioning the position and location applied for, to any nearby NongHyup office or the Human Resources Department.' | translate }}</p>
            <h5>{{ 'career.Head Office in Phnom Penh' | translate }}</h5>
            <p>{{ 'career.Building No. 388A E1, E2, E3, Preah Monivong Blvd. Corner St. 352, Sangkat Boeng Keng Kang1, Khan Boeng Keng Kang, Phnom Penh.' | translate }}</p>
            <p><span>{{ 'career.Email' | translate }}: </span>career&#64;nhfinance.com.kh</p>
            <p><span>{{ 'career.Tel' | translate }}: </span>023 998 226 | 023 996 023</p>
        </div>
        <!-- English -->

        <!-- Khmer -->
        <div class="paragraph" *ngIf="selectedCareer && isKhmer()">
            <h2>{{ selectedCareer.title_kh }}</h2>
            <p *ngIf="selectedCareer.location">{{ 'career.Locations' | translate }}: </p>
            <p [innerHTML]="selectedCareer.branches_kh | safeText"></p>
            <p style="margin-top: 50px;">{{ 'career.Closing date' | translate }}: {{ selectedCareer.close_date | dateFormat }}</p>
            <hr>
            <h1 *ngIf="selectedCareer.duties">{{ 'career.Job Duties and Responsibilities' | translate }}</h1>
            <p [innerHTML]="selectedCareer.duties_kh | safeText"></p>
            <h1 *ngIf="selectedCareer.competencies">{{ 'career.Benefits' | translate }}</h1>
            <p [innerHTML]="selectedCareer.competencies_kh | safeText"></p>
            <hr>
            <h1>{{ 'career.How to apply' | translate }}</h1>
            <p>{{ 'career.Interested candidates should submit a CV, Cover Letter, and recent passport photograph, clearly mentioning the position and location applied for, to any nearby NongHyup office or the Human Resources Department.' | translate }}</p>
            <h5>{{ 'career.Head Office in Phnom Penh' | translate }}</h5>
            <p>{{ 'career.Building No. 388A E1, E2, E3, Preah Monivong Blvd. Corner St. 352, Sangkat Boeng Keng Kang1, Khan Boeng Keng Kang, Phnom Penh.' | translate }}</p>
            <p><span>{{ 'career.Email' | translate }}: </span>career&#64;nhfinance.com.kh</p>
            <p><span>{{ 'career.Tel' | translate }}: </span>023 998 226 | 023 996 023</p>
        </div>
        <!-- Khmer -->


        <div class="bottom-content-poster">
            <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>
